import React from 'react'

export function TermsCheck() {
    return (
        <span className="form__subtitle__link">
            Li e aceito os{' '}
            <a href="/termos-de-uso" target="__blank">
                {' '}
                Termos de Uso{' '}
            </a>{' '}
            e o{' '}
            <a href="/aviso-de-privacidade" target="__blank">
                {' '}
                Aviso de Privacidade{' '}
            </a>
        </span>
    )
}
